/* globals */

import httpClient from './lib/httpClient'

export const login = async (payload) => {
  const endpoint = '/api/Login/login/?username=' + payload.username + "&password=" + payload.password
  return httpClient.get(endpoint)
}

export const changePassword = async (payload) => {
  const endpoint = '/api/Login/changePassword/?companyId=' + payload.companyId + "&oldPassword=" + payload.oldPassword + "&newPassword=" + payload.newPassword
  return httpClient.get(endpoint)
}

export default {
  login,
  changePassword
}
